import { render, staticRenderFns } from "./RetiredSignatureLink.vue?vue&type=template&id=52a28c2c&v-if=uuid&"
import script from "./RetiredSignatureLink.vue?vue&type=script&lang=js&"
export * from "./RetiredSignatureLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports